module.exports = __webpack_public_path__ + "img/game02.82eb0525.png";